import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import styled from 'styled-components';

import Clearfix from 'components/elements/clearfix';
import { SELECT_ITEM_DEFAULT } from 'config';
import { getLookupKhuCumCN } from 'api/lookuplistitemApi';
import { getLabelIndustrialArea } from 'utils/misc';

const Container = styled.div`
  display: flex;
  align-items: center;
`;

export default class KhuCumCongNghiepSelect extends React.Component {
  static propTypes = {
    width: PropTypes.any,
    hideLabel: PropTypes.bool,
    fieldForm: PropTypes.shape({
      form: PropTypes.any,
      name: PropTypes.string,
      option: PropTypes.object,
    }),
  };

  constructor(props) {
    super(props);
    this.state = {
      itemList: [SELECT_ITEM_DEFAULT],
      dataSource: [],
    };
  }

  componentWillMount = async () => {
    const res = await getLookupKhuCumCN();
    if (res.success)
      this.setState({
        dataSource: [
          SELECT_ITEM_DEFAULT,
          ...res.data.map((item) => {
            return {
              value: item._id,
              label: item.Name,
            };
          }),
        ],
      });
  };

  render() {
    const { fieldForm } = this.props;
    let getFieldProps = {};
    if (fieldForm) {
      getFieldProps = fieldForm.form.getFieldProps(fieldForm.name, {
        ...fieldForm.option,
      });
    }

    const isHidden = {
      style: {
        display: this.props.hideLabel ? 'none' : '',
      },
    };

    return (
      <Container>
        <span {...isHidden}>{getLabelIndustrialArea()}</span>
        <Clearfix {...isHidden} width={8} />
        <div style={{ flex: 1 }}>
          <Select
            isClearable
            placeholder='-- Select --'
            style={{
              flex: 1,
            }}
            classNamePrefix='react-select-custom'
            options={this.state.dataSource}
            {...getFieldProps}
          />
        </div>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/elements/select-khu-cum-cong-nghiep/index.js